import React from 'react';
import classNames from 'classnames';
import './consecutive-route-tooltip-data.scss';

interface Translations {
	routeName: string;
	vehicleName: string;
	driverName: string;
}

interface Props {
	routeName: string;
	routeTimes: [string, string];
	translations: Translations;
	driverName?: string;
	vehicleName?: string;
	hasSameDriver?: boolean;
	hasSameVehicle?: boolean;
	color?: string;
}

const ConsecutiveRouteTooltipData = ({
	routeName,
	translations,
	driverName,
	vehicleName,
	color,
	routeTimes,
	hasSameDriver = true,
	hasSameVehicle = true
}: Props) => {
	return (
		<div className="consecutive-route-tooltip-data">
			<div className="consecutive-route-color" style={{ backgroundColor: color || '#fff' }}></div>
			<div className="consecutive-route-data">
				<span className="consecutive-route-name">{`${translations.routeName}: ${routeName} (${routeTimes[0]} - ${routeTimes[1]})`}</span>
				{driverName && (
					<span
						className={classNames('consecutive-route-driver-name', { 'grey-color': !hasSameDriver })}
					>{`${translations.driverName}: ${driverName}`}</span>
				)}
				{vehicleName && (
					<span
						className={classNames('consecutive-route-vehicle-name', { 'grey-color': !hasSameVehicle })}
					>{`${translations.vehicleName}: ${vehicleName}`}</span>
				)}
			</div>
		</div>
	);
};

export default ConsecutiveRouteTooltipData;
